import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/react-hooks';
import { DeveloperSignupView } from './view';
import { USER_SIGNUP } from 'const/mutations';

export function DeveloperSignup() {
    const navigate = useNavigate();
    const [signup, { error, loading }] = useMutation(USER_SIGNUP, {
        onCompleted() {
            navigate('/developer/validate-email');
        },
    });

    const onSubmit = (values, form, callback) => {
        signup({ variables: values })
            .then(() => callback())
            .catch(err => callback(err));
    };

    return <DeveloperSignupView onSubmit={onSubmit} error={error} loading={loading} />;
}
